import riverwatersituationTypes from './types/riverwatersituation'
import riverwatersituationService from '@/api/riverwatersituation'

const state = {}

const actions = {
  /**
   *  获取时段水位统计
   */
  [riverwatersituationTypes.getIntervalWaterStatistics] ({ commit }, { SID = '22', BeginDate = '', EndDate = '', Interval = 1, PageIndex = '1', PageSize = '500' }) {
    return new Promise((resolve, reject) => {
      riverwatersituationService.getIntervalWaterStatistics({ SID, BeginDate, EndDate, Interval, PageIndex, PageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出时段水位统计
   */
  [riverwatersituationTypes.exportIntervalWaterStatistics] ({ commit }, { SID = '22', BeginDate = '', EndDate = '', Interval = 1, PageIndex = '1', PageSize = '500' }) {
    return new Promise((resolve, reject) => {
      riverwatersituationService.exportIntervalWaterStatistics({ SID, BeginDate, EndDate, Interval, PageIndex, PageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 水库时段水位统计
   */
  [riverwatersituationTypes.getReservoirIntervalWaterStatistics] ({ commit }, { SID = '22', BeginDate = '', EndDate = '', PageIndex = '1', PageSize = '500' }) {
    return new Promise((resolve, reject) => {
      riverwatersituationService.getReservoirIntervalWaterStatistics({ SID, BeginDate, EndDate, PageIndex, PageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 水库水位过程
   */
  [riverwatersituationTypes.getReservoirWaterProcedure] ({ commit }, { SID = '22', BeginDate = '', EndDate = '', PageIndex = '1', PageSize = '500' }) {
    return new Promise((resolve, reject) => {
      riverwatersituationService.getReservoirWaterProcedure({ SID, BeginDate, EndDate, PageIndex, PageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出水库时段水位统计
   */
  [riverwatersituationTypes.exportReservoirIntervalWaterStatistics] ({ commit }, { SID = '22', BeginDate = '', EndDate = '', PageIndex = '1', PageSize = '500' }) {
    return new Promise((resolve, reject) => {
      riverwatersituationService.exportReservoirIntervalWaterStatistics({ SID, BeginDate, EndDate, PageIndex, PageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  /**
   * 导出水库水位过程
   */
  [riverwatersituationTypes.exportReservoirWaterProcedure] ({ commit }, { SID = '22', BeginDate = '', EndDate = '', PageIndex = '1', PageSize = '500' }) {
    return new Promise((resolve, reject) => {
      riverwatersituationService.exportReservoirWaterProcedure({ SID, BeginDate, EndDate, PageIndex, PageSize }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
